module.exports = __webpack_public_path__ + "static/img/img_que.7a38388.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/community/img_que.png
// module id = hDy3
// module chunks = 1